import { Form, Input, message, Spin } from "antd";
import React, { Component } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { PageTitle, FormBtn, RequriedText } from "lib/widget";

const FormItem = Form.Item;

export default class PackageGroupForm extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const { errorMessage, alertMessage } = nextProps;

    if (alertMessage !== "") {
      return { alertMessage: alertMessage };
    }

    if (errorMessage !== "") {
      return { errorMessage: errorMessage };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    const { errorMessage, alertMessage } = this.props;
    const prevMsg = prevProps;

    if (errorMessage !== "" && prevMsg.errorMessage !== errorMessage) {
      message.error(errorMessage);
    }

    if (alertMessage !== "" && prevMsg.alertMessage !== alertMessage) {
      message.success(alertMessage);
    }
  }

  isDisabled = () => {
    return this.props.packageGroup.service_package_group_code !== '' && this.props.editCode
  }

  componentDidMount() {
    this.nameInput.focus(); 
  }

  render() {
    const { packageGroup, onSubmit } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      }
    };

    return (
      <div>
        <Spin size="large" spinning={this.props.loading}>
          <PageTitle name="service_package_groups" component={null} />
          <Formik
            initialValues={packageGroup}
            enableReinitialize={true}
            validationSchema={yup.object().shape({
              service_package_group_code: yup
                .string()
                .required("Code is a required field"),
              service_package_group: yup
                .string()
                .required("Name is a required field")
            })}
            onSubmit={values => onSubmit(values)}
            render={({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit
            }) => (
              <Form onFinish={handleSubmit} autoComplete="off">
                <fieldset disabled={!this.props.canEdit}>
                  <FormItem
                    {...formItemLayout}
                    label={<RequriedText label="Code" />}
                    validateStatus={
                      touched.service_package_group_code &&
                      errors.service_package_group_code &&
                      "error"
                    }
                    help={
                      touched.service_package_group_code &&
                      errors.service_package_group_code
                    }
                  >
                    <Input
                      ref={(input) => { this.nameInput = input; }} 
                      name="service_package_group_code"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.service_package_group_code}
                      disabled={this.isDisabled()}
                    />
                  </FormItem>
                  <FormItem
                    {...formItemLayout}
                    label={<RequriedText label="Name" />}
                    validateStatus={
                      touched.service_package_group &&
                      errors.service_package_group &&
                      "error"
                    }
                    help={
                      touched.service_package_group &&
                      errors.service_package_group
                    }
                  >
                    <Input
                      
                      name="service_package_group"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.service_package_group}
                    />
                  </FormItem>
                  <FormBtn
                    url="/service-package/groups"
                    canEdit={this.props.canEdit}
                  />
                </fieldset>
              </Form>
            )}
          />
        </Spin>
      </div>
    );
  }
}
